<template>
  <div>
  <div class="main">
    <div class="col-12 d-md-block d-none">
      <h3 class="subtitle">Troca de Senha</h3><br>
    </div>

    <b-container class="bv-example-row">
      <b-row>
        <b-col sm="6">
          <b-alert show variant="warning" class="text-left small text-uppercase p-10 pb-10 d-flex justify-content-start align-items-center">
            <i class="material-icons pr-1">info </i> A senha deve conter no máximo 8 caracteres
          </b-alert>
        </b-col>
      </b-row>
  </b-container>

  <div class="col-md-6">
    <div class="card card_content shadow-sm p-6">
      <p class="text-left small text-uppercase p-2 pb-3 d-flex justify-content-start align-items-center">
        <i class="material-icons">vpn_key </i> Alterar Senha
      </p>
      <form action @submit.prevent="alterarSenha" class="form_padrao">
        <div class="form-row">
          <div class="form-group flutuante col-12">
            <b-form-input
              type="password"
              name="password"
              id="password"
              v-model="operador.password"
              required
              autocomplete="off"
              maxlength = "8"
            />
            <label for="current-Password">Senha Atual</label>
          </div>
          <div class="form-group flutuante col-12">
            <input
              type="password"
              name="newPassword"
              id="newPassword"
              v-model="operador.newPassword"
              required
              autocomplete="off"
              maxlength = "8"
            />
            <label for="nova-senha">Nova Senha</label>
          </div>
          <div class="form-group flutuante col-12">
            <input
              type="password"
              name="repeatPassword"
              id="repeatPassword"
              v-model="operador.repeatPassword"
              required
              autocomplete="off"
              maxlength = "8"
            />
            <label for="senha">Repetir Senha</label>
          </div>

          <div class="form-group col-12">
              <div
                class="alert alert-danger border-0 text-center"
                v-if="errors"
                role="alert"
              >
                {{
                  errorMsg
                }}
              </div>

            </div>
            
          <div class="form-group col-12">
            <button
              type="submit"
              class="btn btn-verde p-0 fit-content"
              :class="{ 'btn-cinza': !passwordsMatch }"
              :style="{ 'pointer-events': !passwordsMatch ? 'none' : 'auto' }"
              :disabled="loading || !passwordsMatch"
            >

              <span
                class="spinner-grow spinner-grow-sm pr-2"
                role="status"
                aria-hidden="true"
                v-show="loading"
              ></span>
              <span v-if="loading">Processando</span>
              <span v-else>Alterar</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  </div>
</div>
</template>

<script>
import { formata } from "../../helpers";
export default {
name: "MeuPlano",
components: {},
data() {
  return {
    loading: false,
    closeModal: false,
    errors: false,
    errorMsg: "",
    operador: {
      password: null,
      newPassword: null,
      repeatPassword: null
    },
    valorPacote: formata(this.$user.planoUnitario),
    situacao: "",
    passwordsMatch: false
  };
},
watch: {

  'operador.newPassword'() {
    this.validatePasswordsMatch();
  },

  'operador.repeatPassword'() {
    this.validatePasswordsMatch();
  }
},
methods: {
  
  validatePasswordsMatch() {
    if (this.operador.newPassword !== this.operador.repeatPassword) {
      this.errors = true;
      this.errorMsg = 'Senhas não correspondem';
      this.passwordsMatch = false;
    } else {this.errors = false;
      this.errorMsg = '';
      this.passwordsMatch = true;
    }
  },
  
  alterarSenha() {
  
    this.errors = false;
    this.errorMsg = "";

    if (this.operador.newPassword !== this.operador.repeatPassword) {
      this.errors = true;
      this.errorMsg = "'Nova Senha' e 'Repetir Senha' são diferentes, por favor inserir a mesma senha!";
      return false;
    }

    if (this.operador.password === this.operador.newPassword) {
      this.errors = true;
      this.errorMsg = "Senha Atual é igual a Nova Senha, favor alterar!";
      return false;
    }

     this.loading = true;
     this.error = false;

      this.$http
       .post("/Login/ResetarSenha", {
          newPassword: this.operador.newPassword,
          password: this.operador.password
       })
       .then((response) => {
        this.$toast.open({
            message: response.data.mensagem,
            type: "success",
            duration: 6000,
        });
        this.loading = false;
        this.operador = {};
       })
       .catch((error) => {
        if (error.response.status === 400) {
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
          }
          this.loading = false;
        });
     
  }
},
created() {
  if (this.$user.situacaoAssociado == "A") {
    this.situacao = "Ativo";
  } else if (this.$user.situacaoAssociado == "I") {
    this.situacao = "Inativo";
  }
},
};
</script>
<style lang="scss" scoped>
.form_padrao {
.form-group.flutuante {
  position: relative;
  input[type="text"],
  input[type="password"],
  input[type="email"],
  input[type="tel"],
  textarea {
    background: #eff5e7;
  }
}
.fit-content {
  max-width: fit-content;
  padding: 0.6rem 1rem !important;
}
}
@media screen and(max-width: 900px) {
.fit-content {
  max-width: 100% !important;
}
}

.card_content {
min-height: 170px;
display: flex;
justify-content: space-between;
small {
  line-height: 1.5rem;
}

.btn-cinza {
  background-color: #999999 !important;
  color: #ffffff !important;
  border-color: #999999;
}

.btn-cinza:hover {
  background-color: #999999 !important;
  color: #ffffff !important;
  border-color: #999999;
}

}
</style>
